import React, { Component } from 'react'
import Banner from '../../components/tribe/tribe_banner2'
import './css/index.css'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer' 
import Assestment1 from '../../assets/image/assesment1.png'
import virtual from '../../assets/image/assestment/virtual.jpg'
export default class virtual_assestment extends Component {
    render() {
        const image=[
            {image:virtual}
        ]
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br className='hide-mobile'/><br className='hide-mobile'/>
                <div className='consulting-section'>
                    <Banner bread_crum={['Assessment','Virtual Assessment Center']} image={image} title="Virtual Assessment Center" subtitle=""/>
                    <br/><br/>
                    <div className='consulting-content'>
                        <h2>How we work</h2>
                        <br/><br/>
                        <div className='how'>
                            <p>
                                Simulates an online desktop environment, where Participants are presented with a variety of information and business issues.
                                <br/><br/>
                                <img src={Assestment1}/>
                                <br/><br/>
                            </p>
                        </div>
                    </div>
                </div>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
